import { type KeyboardEvent } from 'react'
import { observer } from 'mobx-react-lite'
import { type Observable } from 'rxjs'
import { type TextQuestionAnswerEditorViewModel } from '@/features/jobs/questions/text/TextQuestionAnswerEditorViewModel'
import { TextQuestionAnswerEditor } from '@/features/jobs/questions/text/components/TextQuestionAnswerEditor'

export interface TextQuestionAnswerEditorContainerProps {
  editorVm: TextQuestionAnswerEditorViewModel
  questionId: string
  isDisabled: boolean
  focus$?: Observable<unknown>
  onFocus?: () => unknown
  onEnterDown?: (e: KeyboardEvent) => unknown
  isNotValid?: boolean
}

export const TextQuestionAnswerEditorContainer = observer(
  function TextQuestionAnswerEditorContainer({
    editorVm,
    questionId,
    ...rest
  }: TextQuestionAnswerEditorContainerProps) {
    return (
      <TextQuestionAnswerEditor
        value={editorVm.editingValue}
        onChange={editorVm.setEditingValue}
        onCommit={editorVm.flush}
        testId={`text-answer-${questionId}`}
        {...rest}
      />
    )
  },
)
